<template>
    <template v-if="showVerify">
        <router-view v-slot="{ Component }">
            <component :is="Component"></component>  
        </router-view>
    </template>
    <template v-else>
    <div class="container min-vh-100">
        <div class="row flex-column-reverse flex-lg-row position-relative login-flex-wrap">
            <LoginLeft></LoginLeft>

            <div class="col flex-grow-1 col-lg-4 col-md-6 col-12 align-items-center d-flex p-5 justify-content-center align-content-center top-position-tablet right-content flex-wrap" data-mdb-animation="zoom-in" data-mdb-animation-start="onLoad" >
                <div class="login-logo pt-0 pr-4 pb-4 pl-4">
                    <a href="/home">
                    <!--<img src="{{ asset('/images/gizmorilla_logo.png') }}" alt="digital art media nova GmbH Logo" class="brand-image" />-->
                        <inline-svg src="/assets/images/gizmorilla_eu.svg" alt="Gizmorilla Logo" class="brand-image"></inline-svg>
                    </a>
                </div>

                <div class="row justify-content-center">
                    <div class="col-12 align-self-center overflow-visible p-0 right-content-interior relative">
                        <router-view v-slot="{ Component }">
                            <component :is="Component"></component>  
                        </router-view>
                        <LoginLangSwitch></LoginLangSwitch>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </template>
</template>
<script>
    import LoginLeft from './partials/LoginLeft.vue';
    import LoginLangSwitch from './partials/LoginLangSwitch.vue';
    import '../../../sass/fe_login.scss';
    
    export default {
        name: 'Auth',
        data(){
            return {
                
            }
        },
        computed:{
            showVerify () {
                return this.$route.meta.showVerify;
            }
        }
        ,components:{
            LoginLeft,
            LoginLangSwitch
        }
        ,created(){
            
        }
        ,mounted() {

        }
        ,methods: {

        }
    }
</script>